import { Discont, DiscontStatus } from "../types/discont.type";


export class OrderLogicShare {
    /**
      * Вычисляет сумму персональной скидки на заказ.
      *
      * Скидка применяется только если:
      * - передан объект скидки (discont)
      * - статус скидки равен DiscontStatus.OK
      * - итоговая сумма заказа (currentPrice * count) превышает или равна пороговому значению discont.start_sum
      *
      * @param currentPrice - Текущая цена одной единицы товара/услуги.
      * @param discont - Объект скидки (тип Discont) или undefined, если скидка не применяется.
      * @param count - Количество единиц товара/услуги в заказе.
      * @returns {number} Сумма скидки в рублях. Если условия не выполнены — возвращает 0.
      */
    static discontSum(currentPrice: number, discont: Discont | undefined, count: number) {
        if (discont && discont.status === DiscontStatus.OK) {
            const discontSum = currentPrice * count;
            if (discontSum >= discont.start_sum) {
                return Math.round(discontSum * (discont.percent / 100));
            }
            return 0;
        }
        return 0;
    }

    /**
     * Вычисляет сумму скидки за количество.
     *
     * @param price_max - Максимальная цена одной единицы товара/услуги.
     * @param currentPrice - Текущая цена одной единицы товара/услуги.
     * @param count - Количество единиц товара/услуги в заказе.
     * @returns {number} Сумма скидки за количество в рублях.
     */
    static countDiscont(price_max: number, currentPrice: number, count: number) {
        return Math.round(price_max * count) - (currentPrice * count);
    }
    /**
     * Вычисляет итоговую сумму заказа.
     *
     * @param price_max - Максимальная цена одной единицы товара/услуги.
     * @param count - Количество единиц товара/услуги в заказе.
     * @param discontSum - Сумма персональной скидки.
     * @param countDiscont - Сумма скидки за количество.
     * @returns {number} Итоговая сумма заказа в рублях.
     */
    static totalPrice(price_max: number, count: number, discontSum: number, countDiscont: number) {
        return price_max * count - discontSum - countDiscont;
    }

    /**
     * Проверяет, доступна ли скидка для заказа.
     *
     * @param currentPrice - Текущая цена одной единицы товара/услуги.
     * @param discont - Объект скидки (тип Discont) или undefined, если скидка не применяется.
     * @param count - Количество единиц товара/услуги в заказе. 
     * @returns {boolean} true, если скидка доступна, false в противном случае.
     */
    static isValidSum(currentPrice: number, discont: Discont | undefined, count: number) {
        if (discont && discont.status === DiscontStatus.OK) {
            return currentPrice * count > discont.start_sum;
        }
        return true;
    }

    /**
     * Вычисляет итоговую сумму заказа.
     *
     * @param price_max - Максимальная цена одной единицы товара/услуги.
     * @param count - Количество единиц товара/услуги в заказе.
     * @returns {number} Итоговая сумма заказа в рублях.
     */
    static viewTotalMaxPrice(price_max: number, count: number) {
        return price_max * count;
    }

    /**
     * Вычисляет сумму, которую не хватает для скидки.
     *
     * @param currentPrice - Текущая цена одной единицы товара/услуги.
     * @param discont - Объект скидки (тип Discont).
     * @param count - Количество единиц товара/услуги в заказе. 
     * @returns {number} Сумма, которую не хватает для скидки в рублях.
     */
    static viewFailTotalDiscont(currentPrice: number, discont: Discont, count: number) {
        return currentPrice * count - discont.start_sum;
    }


    static getActiveStepIndex(steps: number[], count: number) {
        // Определяем активный шаг
        const activeStepIdx = steps.reduce((acc, step, idx) => count >= step ? idx : acc, 0);
        return activeStepIdx;
    }

    static getStepPrice(steps: number[], price_max: number, price_min: number, stepIndex: number) {
        return Math.round(price_max - (price_max - price_min) * (stepIndex / (steps.length - 1)));
    }
}